<mat-toolbar class="cont-width">
  <a
    [routerLink]="!missingFields ? ['/', currentLang(), 'home'] : null"
    routerLinkActive="active"
    class="title-link">
    <img
      ngSrc="logo_szlogen.png"
      height="40"
      width="212"
      priority
      alt="Globodog Logo" />
  </a>
  <span class="spacer"></span>
  <app-notification-bell
    id="mobile-bell"
    *ngIf="isMobile()"></app-notification-bell>
  <div id="hamburger-menu">
    <button
      mat-icon-button
      aria-label="Menu"
      (click)="showMobileMenu.set(true)">
      <mat-icon>menu</mat-icon>
    </button>
  </div>

  <div id="large-menu">
    <a
      mat-button
      [routerLink]="
        !missingFields ? ['/', currentLang(), 'recommend-owner'] : null
      "
      routerLinkActive="active"
      >{{ 'Kutyásoknak' | translate }}</a
    >
    <a
      mat-button
      [routerLink]="
        !missingFields ? ['/', currentLang(), 'recommend-provider'] : null
      "
      routerLinkActive="active"
      >{{ 'Szolgáltatóknak' | translate }}</a
    >
    <a
      mat-button
      [routerLink]="
        !missingFields ? ['/', currentLang(), 'globomarket'] : null
      "
      routerLinkActive="active"
      >{{ 'GloboMarket' | translate }}</a
    >
    <!--
    <a
      mat-button
      [routerLink]="!missingFields ? ['/', currentLang(), 'media-offer'] : null"
      routerLinkActive="active"
      >{{ 'Médiaajánlat' | translate }}</a
    >
    -->    
    <mat-divider
      class="dotted"
      *ngIf="!missingFields"
      [vertical]="true"></mat-divider>
    <ng-template [ngIf]="isLoggedIn()" [ngIfElse]="anonymousContent">
      <ng-container *ngIf="!missingFields">
        <a
          [routerLink]="['/', currentLang(), 'profile']"
          color="primary"
          routerLinkActive="active"
          mat-button
          >{{ 'Profilom' | translate }}</a
        >
      </ng-container>
    </ng-template>
    <ng-template #anonymousContent>
      <a mat-button [routerLink]="['/', currentLang(), 'login']"
        ><span class="align-center"
          ><img
            ngSrc="ui/login-icon.svg"
            height="16"
            width="16"
            priority
            alt="Login icon" /><span>{{
            'Bejelentkezés' | translate
          }}</span></span
        ></a
      >
    </ng-template>
    <mat-divider
      class="dotted"
      [vertical]="true"
      *ngIf="isLoggedIn()"></mat-divider>
    <button mat-button (click)="logout()" *ngIf="isLoggedIn()">
      {{ 'Kijelentkezés' | translate }}
    </button>
    <mat-divider class="dotted" [vertical]="true"></mat-divider>
    <app-lang-selector></app-lang-selector>
    <app-notification-bell *ngIf="!isMobile()"></app-notification-bell>
  </div>
</mat-toolbar>
<div #mobileMenu class="mobile-menu" *ngIf="showMobileMenu()">
  <button
    id="mobile-menu-close-button"
    mat-icon-button
    (click)="showMobileMenu.set(false)">
    <mat-icon>close</mat-icon>
  </button>
  <a [routerLink]="['/', currentLang(), 'home']" cdkMenuItem>{{
    'Főoldal' | translate
  }}</a>
  <mat-divider class="dotted"></mat-divider>
  <ng-template [ngIf]="!isLoggedIn()">
    <a
      [routerLink]="['/', currentLang(), 'login']"
      mat-link-button
      cdkMenuItem
      class="extra-top-padding"
      >{{ 'Bejelentkezés' | translate }}</a
    >
    <mat-divider class="dotted"></mat-divider>
  </ng-template>
  <ng-template [ngIf]="isLoggedIn()">
    <a
      [routerLink]="['/', currentLang(), 'profile']"
      mat-link-button
      cdkMenuItem
      color="primary"
      class="extra-top-padding"
      >{{ 'Profilom' | translate }}</a
    >
    <mat-divider class="dotted"></mat-divider>
  </ng-template>
  <a [routerLink]="['/', currentLang(), 'recommend-owner']" cdkMenuItem>{{
    'Kutyásoknak' | translate
  }}</a>
  <a [routerLink]="['/', currentLang(), 'recommend-provider']" cdkMenuItem>{{
    'Szolgáltatóknak' | translate
  }}</a>
  <a [routerLink]="['/', currentLang(), 'globomarket']" cdkMenuItem>{{
    'GloboMarket' | translate
  }}</a>
  <!--
  <a [routerLink]="['/', currentLang(), 'media-offer']" cdkMenuItem>{{
    'Médiaajánlat' | translate
  }}</a>
  -->
  
  <mat-divider class="dotted"></mat-divider>
  <ng-template [ngIf]="isLoggedIn()">
    <a
      [routerLink]="['/', currentLang(), 'logout']"
      (click)="logout()"
      mat-link-button
      cdkMenuItem
      >{{ 'Kijelentkezés' | translate }}</a
    >
    <mat-divider class="dotted"></mat-divider>
  </ng-template>
  <div>
    <app-lang-selector [contrastColor]="true"></app-lang-selector>
  </div>
</div>
